import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Button } from "primereact/button";
import { InputText } from "primereact/inputtext";
import { Dropdown } from "primereact/dropdown";
import { RadioButton } from "primereact/radiobutton";
import { Calendar } from "primereact/calendar";
import { Toast } from "primereact/toast";
import ClienteActions from "../../clientes/components/ClienteActions.js";
import {
  postGrabar,
  clienteBoletaGrabar,
  getCotizacion,
} from "../../../service/AffariService.js";
import ValidezDialog from "./dialogs/ValidezDialog.js";
import ObrasDialog from "./dialogs/ObraDialog.js";
import CondicionesDialog from "../../condiciones/CondicionesDialog.js";
import LoaderTransparent from "../../../components/ui/LoaderTransparent.js";
import { useOffline } from "../../../offline/OfflineContext.js";
import { crearCotizacionOffline } from "../../../offline/offlineCotizacionService";

const Cabecera = ({
  tipoDocumento,
  data,
  setData,
  setCodigo,
  setIdCotizacion,
  setIsContactoDialogVisible,
  setIsDatosDialogVisible,
  setIsDeudaDialogVisible,
  setIsVentaDialogVisible,
  setIsTicketsDialogVisible,
  setIsSincronizarDialogVisible,
  setCollapsedClient,
  setCollapsedFolio,
  setIsDetalleVisible,
  toastRef,
  loading,
  setLoading,
}) => {
  const navigate = useNavigate();
  const [isValidezDialogVisible, setIsValidezDialogVisible] = useState(false);
  const [isObraDialogVisible, setIsObraDialogVisible] = useState(false);
  const [codigoCliente, setCodigoCliente] = useState("");
  const [isCondicionesDialogVisible, setIsCondicionesDialogVisible] =
    useState(false);

  const toast = toastRef;
  const { offlineMode } = useOffline();

  const getCodigoCliente = () => {
    return data?.cliente?.codigo || data?.codigo || codigoCliente || "";
  };

  const selectdatos = () => {
    const codigo = getCodigoCliente();
    if (!codigo) return;

    setCodigo(codigo);
    setIsDatosDialogVisible(true);
  };

  const selectdeuda = () => {
    const codigo = getCodigoCliente();
    if (!codigo) return;

    setCodigo(codigo);
    setIsDeudaDialogVisible(true);
  };

  const selectventa = () => {
    const codigo = getCodigoCliente();
    if (!codigo) return;

    setCodigo(codigo);
    setIsVentaDialogVisible(true);
  };

  const selecttickets = () => {
    const codigo = getCodigoCliente();
    if (!codigo) return;

    setCodigo(codigo);
    setIsTicketsDialogVisible(true);
  };

  const selectValidez = () => {
    setIsValidezDialogVisible(true);
    setCodigoCliente(data.cliente.codigo);
  };

  const selectObra = () => {
    setIsObraDialogVisible(true);
    setCodigoCliente(data.cliente.codigo);
  };

  const selectCondiciones = () => {
    setIsCondicionesDialogVisible(true);
    setCodigoCliente(data.cliente.codigo);
  };

  const [loadingCotizacion, setLoadingCotizacion] = useState(false);

  const handleObrasListaChange = (lista) => {
    setData((prev) => ({ ...prev, obras: lista }));
  };

  const handleCondicionesChange = (lista) => {
    setData((prev) => ({ ...prev, condiciones: lista }));
  };

  const handleValidezListaChange = (lista) => {
    setData((prev) => ({ ...prev, validezs: lista }));
  };

  const selectActualizar = async (rowData) => {
    const codigoCli = rowData?.cliente?.codigo;
    setCodigo(codigoCli);
    if (typeof setIsSincronizarDialogVisible === "function") {
      setIsSincronizarDialogVisible(true);
    } else if (codigoCli) {
      if (offlineMode) {
        toast.current?.show({
          severity: "info",
          summary: "Modo offline",
          detail: "Actualizar cliente no está disponible.",
          life: 3000,
        });
        return;
      }
      try {
        setLoadingCotizacion(true);
        await getCotizacion(codigoCli);
        toast?.current?.show({
          severity: "success",
          summary: "Cotización actualizada",
          life: 3000,
        });
      } catch (error) {
        toast?.current?.show({
          severity: "error",
          summary: "Cotización",
          detail: "No se pudo actualizar la cotización",
          life: 3000,
        });
      } finally {
        setLoadingCotizacion(false);
      }
    }
  };

  const cotizacionNormal = async () => {
    setLoading(true);

    if (!data.cliente?.codigo) {
      toast.current?.show({
        severity: "warn",
        summary: "Cliente",
        detail: "Selecciona un cliente antes de continuar.",
        life: 3000,
      });

      setLoading(false);
      return;
    }

    if (!data.contacto) {
      toast.current?.show({
        severity: "warn",
        summary: "Contacto",
        detail: "Ingresa el contacto.",
        life: 3000,
      });

      setLoading(false);
      return;
    }

    if (!(data.estado?.id || data.estado)) {
      toast.current?.show({
        severity: "warn",
        summary: "Estado",
        detail: "Selecciona el estado de la cotización.",
        life: 3000,
      });

      setLoading(false);
      return;
    }

    if (!(data.validez || data.validezs?.[0]?.id)) {
      toast.current?.show({
        severity: "warn",
        summary: "Validez",
        detail: "Selecciona la validez de la oferta.",
        life: 3000,
      });

      setLoading(false);
      return;
    }

    if (data.interfaz === "MAYORISTA") {
      const obraSeleccionada = data.obra?.id || data.obra;
      const centroSeleccionado = data.almacen;

      if (!obraSeleccionada) {
        toast.current?.show({
          severity: "warn",
          summary: "Obra",
          detail: "Selecciona la obra antes de continuar.",
          life: 3000,
        });

        setLoading(false);
        return;
      }

      if (!centroSeleccionado) {
        toast.current?.show({
          severity: "warn",
          summary: "Centro",
          detail: "Selecciona el centro antes de continuar.",
          life: 3000,
        });

        setLoading(false);
        return;
      }

      if (!data.fechaDecision) {
        toast.current?.show({
          severity: "warn",
          summary: "Fecha decisión",
          detail: "Selecciona la fecha de decisión.",
          life: 3000,
        });

        setLoading(false);
        return;
      }

      if (!data.fechaEntrega) {
        toast.current?.show({
          severity: "warn",
          summary: "Fecha entrega",
          detail: "Selecciona la fecha de entrega.",
          life: 3000,
        });

        setLoading(false);
        return;
      }
    }

    if (offlineMode) {
      try {
        const response = await crearCotizacionOffline(data, tipoDocumento);
        setIdCotizacion(response.idLocal);

        if (setCollapsedClient) setCollapsedClient(true);
        if (setCollapsedFolio) setCollapsedFolio(false);

        setData((prevData) => ({
          ...prevData,
          idCotizacion: response.idLocal,
          codigo: response.idLocal,
          folioLocal: response.folioLocal,
          estadoSync: "PENDIENTE",
        }));
        setIsDetalleVisible(true);

        toast.current?.show({
          severity: "success",
          summary: "Cotización offline",
          detail: `Cotización local ${response.folioLocal} creada.`,
          life: 3000,
        });
      } catch (error) {
        console.error("Error creando cotización offline:", error);
        toast.current?.show({
          severity: "error",
          summary: "Cotización offline",
          detail: "No se pudo crear la cotización local.",
          life: 3500,
        });
      } finally {
        setLoading(false);
      }

      return;
    }

    try {
      let idDatoClienteBoleta;
      const esBoleta = data.documento === "Boleta" || data.documento === "ZBOE";
      if (esBoleta && data.clienteBoleta) {
        if (
          !data.clienteBoleta.correo ||
          !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(data.clienteBoleta.correo)
        ) {
          setLoading(false);
          if (toast.current)
            toast.current.show({
              severity: "warn",
              summary: "Datos incompletos",
              detail: "Ingresa un correo electrónico válido.",
              life: 3000,
            });
          return;
        }

        if (
          !data.clienteBoleta.nombre ||
          !/^[a-zA-ZáéíóúÁÉÍÓÚñÑ\s]+$/.test(data.clienteBoleta.nombre)
        ) {
          setLoading(false);
          if (toast.current)
            toast.current.show({
              severity: "warn",
              summary: "Datos incompletos",
              detail: "Ingresa un nombre válido.",
              life: 3000,
            });
          return;
        }

        if (!data.clienteBoleta.telefono) {
          setLoading(false);
          if (toast.current)
            toast.current.show({
              severity: "warn",
              summary: "Datos incompletos",
              detail: "Ingresa un teléfono válido.",
              life: 3000,
            });
          return;
        }

        const r = await clienteBoletaGrabar(
          data.clienteBoleta.correo,
          data.clienteBoleta.nombre,
          data.clienteBoleta.telefono,
        );
        if (r?.resultado && r?.id) {
          idDatoClienteBoleta = r.id;
          //toast.current?.show({ severity: 'success', summary: 'Cliente Boleta', detail: 'Datos de boleta registrados con éxito.', life: 3500 });
        } else {
          toast.current?.show({
            severity: "error",
            summary: "Cliente Boleta",
            detail: "No se pudo registrar los datos de boleta.",
            life: 3500,
          });
          return;
        }
      }

      const idAlmacen =
        data.interfaz === "MAYORISTA"
          ? data.almacen?.almacen // centro seleccionado en mayorista
          : data.cliente?.listaPrecio?.almacen; // default retail

      const response = await postGrabar({
        id_cotizacion: data.tipoCotizacion,
        cliente: data.cliente?.codigo,
        id_estado: data.estado?.id,
        id_lista_precio: data.cliente?.listaPrecio?.codigo,
        id_almacen: idAlmacen,
        fecha_decision: data.fecha,
        fecha_entrega: data.fecha,
        obra: data.obra?.id || data.obra || "0",
        proyecto: data.proyecto || "0",
        contacto: data.contacto?.id || data.contacto || 0,
        condicion: "3",
        validez: data.validez || data.validezs?.[0]?.id,
        documento: esBoleta
          ? "ZBOE"
          : data.documento === "Factura"
          ? "ZSDE"
          : data.documento,
        id_dato_cliente_boleta: idDatoClienteBoleta || 0,
      });
      if (response?.cotizacion && response?.resultado) {
        setIdCotizacion(response.cotizacion);
        if (setCollapsedClient) setCollapsedClient(true);
        if (setCollapsedFolio) setCollapsedFolio(false);

        try {
          setData((prevData) => ({
            ...prevData,
            idCotizacion: response.cotizacion,
            codigo: response.cotizacion,
          }));
          setIsDetalleVisible(true);
        } catch (error) {
          console.error(
            "Error al cargar datos adicionales de la cotización:",
            error,
          );
        }

        toast.current?.show({
          severity: "success",
          summary: "Cotización",
          detail: `Cotización ${response.cotizacion} creada.`,
          life: 3000,
        });
      } else {
        toast.current?.show({
          severity: "error",
          summary: "Cotización",
          detail: "No se pudo crear la cotización.",
          life: 3500,
        });
      }
    } catch (error) {
      console.error("Error al crear/actualizar la cotización:", error);
      toast.current?.show({
        severity: "error",
        summary: "Cotización",
        detail: "Ocurrió un error al procesar la cotización.",
        life: 3500,
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <div className="col-12" style={{ position: "relative" }}>
        {loading && <LoaderTransparent coverParent overlayTint="transparent" />}
        {!toastRef && (
          <Toast
            ref={toast}
            position="top-right"
            baseZIndex={3000}
            appendTo={document.body}
          />
        )}
        {/* SECCIÓN 1: CLIENTE, CONTACTO Y DOCUMENTO */}
        <div className="grid align-items-start mb-3 border-bottom-1 surface-border pb-3">
          {/* CLIENTE */}
          <div className="col-12 md:col-3 border-right-1 surface-border">
            <label
              htmlFor="cliente"
              className="text-500 font-medium text-xs block mb-1"
            >
              Información Cliente
            </label>
            {/* datos */}
            <div className="text-900 font-bold text-xl mb-2">
              {data.cliente
                ? `${data.cliente.codigo} - ${data.cliente.razonSocial}`
                : "No seleccionado"}
            </div>
            {data.cliente && (
              <div className="text-600 text-sm">
                <i className="pi pi-id-card mr-1"></i>
                {data.cliente.rut}
                <span className="mx-2 text-300">|</span>
                <i className="pi pi-map-marker mr-1"></i>
                {data.cliente.direccion}
              </div>
            )}

            {/* Acciones cliente */}
            <div className="mt-3">
              <ClienteActions
                step="cotizacion"
                rowData={data}
                onSelectDatos={selectdatos}
                onSelectDeuda={selectdeuda}
                onSelectTickets={selecttickets}
                onSelectVenta={selectventa}
                onActualizarCliente={selectActualizar}
                loadingCotizacion={loadingCotizacion}
                tipoDocumento={tipoDocumento}
              />
            </div>
          </div>

          {/* CONFIGURACION DE VENTA */}
          <div className="col-12 md:col-9 pl-4">
            <div className="grid p-fluid">
              {/* CONTACTO */}
              <div className="col-12 md:col-4">
                <label
                  htmlFor="contacto"
                  className="text-500 font-medium text-xs block mb-1"
                >
                  Contacto
                </label>
                <div className="p-inputgroup h-2rem">
                  <Dropdown
                    id="contacto"
                    value={data.contacto}
                    options={data.contactos || []}
                    optionLabel={(contacto) =>
                      `${contacto.nombre} - ${contacto.email}`
                    }
                    placeholder="Seleccionar"
                    className="p-inputtext-sm h-2rem contacto-dropdown"
                    style={{ height: "2rem" }}
                    onChange={(e) => setData({ ...data, contacto: e.value })}
                  />
                  <Button
                    icon="pi pi-cog"
                    className="p-button-outlined p-button-primary p-button-sm"
                    onClick={() => setIsContactoDialogVisible(true)}
                    title="Agregar contacto"
                    tooltip="Gestionar Contactos"
                    tooltipOptions={{ position: "top" }}
                  />
                </div>
              </div>

              {data.interfaz !== "MAYORISTA" &&
                tipoDocumento !== "nota-venta" && ( //para mayoristas y notas de venta no se muestra el tipo de documento
                  <>
                    {/* Seleccionar Tipo de Documento */}
                    <div className="col-12 md:col-8">
                      <label className="text-500 font-medium text-xs block mb-1">
                        Tipo de Documento
                      </label>
                      <div className="flex flex-column md:flex-row align-items-start md:align-items-center gap-2 md:gap-4">
                        {/* boleta */}
                        <div
                          className={
                            tipoDocumento === "factura" ? "hidden" : ""
                          }
                        >
                          <RadioButton
                            inputId="doc_Boleta"
                            name="documento"
                            value="ZBOE"
                            onChange={(e) =>
                              setData({ ...data, documento: e.value })
                            }
                            checked={
                              data.documento === "ZBOE" ||
                              data.documento === "Boleta"
                            }
                          />
                          <label
                            htmlFor="doc_Boleta"
                            className="ml-2 text-sm cursor-pointer text-900"
                          >
                            Boleta
                          </label>
                        </div>

                        {/* factura */}
                        <div className="flex align-items-center">
                          <RadioButton
                            inputId="doc_Factura"
                            name="documento"
                            value="ZSDE"
                            onChange={(e) => {
                              //si se ejecuta desde boleta y se confirma la redireccion a factura, envia a clientes factura
                              if (tipoDocumento === "boleta") {
                                if (
                                  window.confirm(
                                    "Será redireccionado a la sección de Factura. ¿Desea continuar?",
                                  )
                                ) {
                                  navigate("/factura");
                                }
                                //si se ejecuta desde factura se selecciona el valor ZSDE
                              } else {
                                setData({ ...data, documento: e.value });
                              }
                            }}
                            checked={
                              data.documento === "ZSDE" ||
                              data.documento === "Factura"
                            }
                          />
                          <label
                            htmlFor="doc_Factura"
                            className="ml-2 text-sm cursor-pointer text-900"
                          >
                            Factura
                          </label>
                        </div>

                        {/* guia / factura */}
                        {[
                          "ZSDE",
                          "ZSME",
                          "ZFME",
                          "ZVTS",
                          "ZVFX",
                          "Factura",
                        ].includes(data.documento) && (
                          <>
                            {/* guia */}
                            <div className="flex align-items-center">
                              <RadioButton
                                inputId="doc_GuiaFactura"
                                name="documento"
                                value="ZSME"
                                onChange={(e) =>
                                  setData({ ...data, documento: e.value })
                                }
                                checked={data.documento === "ZSME"}
                              />
                              <label
                                htmlFor="doc_GuiaFactura"
                                className="ml-2 text-sm cursor-pointer text-900"
                              >
                                Guia / Factura
                              </label>
                            </div>
                            {/* venta calzada */}
                            <div className="flex align-items-center">
                              <RadioButton
                                inputId="doc_VentaCalzada"
                                name="documento"
                                value="ZFME"
                                onChange={(e) =>
                                  setData({ ...data, documento: e.value })
                                }
                                checked={data.documento === "ZFME"}
                              />
                              <label
                                htmlFor="doc_VentaCalzada"
                                className="ml-2 text-sm cursor-pointer text-900"
                              >
                                Venta Calzada
                              </label>
                            </div>
                            {/* servicio sack */}
                            <div className="flex align-items-center">
                              <RadioButton
                                inputId="doc_ServicioSack"
                                name="documento"
                                value="ZVTS"
                                onChange={(e) =>
                                  setData({ ...data, documento: e.value })
                                }
                                checked={data.documento === "ZVTS"}
                              />
                              <label
                                htmlFor="doc_ServicioSack"
                                className="ml-2 text-sm cursor-pointer text-900"
                              >
                                Servicio Sack
                              </label>
                            </div>
                            {/* exportacion */}
                            <div className="flex align-items-center">
                              <RadioButton
                                inputId="doc_Exportacion"
                                name="documento"
                                value="ZVFX"
                                onChange={(e) =>
                                  setData({ ...data, documento: e.value })
                                }
                                checked={data.documento === "ZVFX"}
                              />
                              <label
                                htmlFor="doc_Exportacion"
                                className="ml-2 text-sm cursor-pointer text-900"
                              >
                                Exportación
                              </label>
                            </div>
                          </>
                        )}
                      </div>
                    </div>
                  </>
                )}

              {/* contacto de cliente boleta */}
              {data.documento === "Boleta" && ( // solo para boletas se solicita ingresar los datos del cliente
                <div className="col-12 ">
                  <label className="text-500 font-medium text-xs block mb-1">
                    Datos Cliente Boleta
                  </label>
                  <div className="flex gap-2">
                    {/*Nombre*/}
                    <div className="flex-grow-1">
                      <span className="p-input-icon-left w-full">
                        <i className="pi pi-user text-sm" />
                        <InputText
                          value={data.clienteBoleta?.nombre || ""}
                          onChange={(e) =>
                            setData({
                              ...data,
                              clienteBoleta: {
                                ...data.clienteBoleta,
                                nombre: e.target.value,
                              },
                            })
                          }
                          placeholder="Nombre"
                          className="w-full p-inputtext-sm"
                        />
                      </span>
                    </div>
                    {/*Correo*/}
                    <div className="flex-grow-1">
                      <span className="p-input-icon-left w-full">
                        <i
                          className={`pi ${
                            data.clienteBoleta?.correo &&
                            !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(
                              data.clienteBoleta.correo,
                            )
                              ? "pi-exclamation-circle text-red-500"
                              : "pi-envelope"
                          } text-sm`}
                        />
                        <InputText
                          value={data.clienteBoleta?.correo || ""}
                          onChange={(e) =>
                            setData({
                              ...data,
                              clienteBoleta: {
                                ...data.clienteBoleta,
                                correo: e.target.value,
                              },
                            })
                          }
                          placeholder="Correo"
                          className={`w-full p-inputtext-sm ${
                            data.clienteBoleta?.correo &&
                            !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(
                              data.clienteBoleta.correo,
                            )
                              ? "p-invalid"
                              : ""
                          }`}
                        />
                      </span>
                    </div>
                    {/*Telefono*/}
                    <div className="flex-grow-1">
                      <span className="p-input-icon-left w-full">
                        <i
                          className={`pi ${
                            data.clienteBoleta?.telefono &&
                            !/^\+56\d{9}$/.test(data.clienteBoleta.telefono)
                              ? "pi-exclamation-circle text-red-500"
                              : "pi-phone"
                          } text-sm`}
                        />
                        <InputText
                          value={data.clienteBoleta?.telefono || "+56"}
                          onChange={(e) => {
                            let val = e.target.value;
                            if (!val.startsWith("+56")) {
                              // Si borra el prefijo, intentamos recuperarlo o reiniciarlo
                              const nums = val.replace(/\D/g, "");
                              val = "+56" + nums;
                            } else {
                              // Mantiene formato +56XXXXXXXXX
                              val = "+56" + val.substring(3).replace(/\D/g, "");
                            }
                            if (val.length > 12) return; // +56 + 9 dígitos
                            setData({
                              ...data,
                              clienteBoleta: {
                                ...data.clienteBoleta,
                                telefono: val,
                              },
                            });
                          }}
                          placeholder="Teléfono"
                          className={`w-full p-inputtext-sm ${
                            data.clienteBoleta?.telefono &&
                            !/^\+56\d{9}$/.test(data.clienteBoleta.telefono)
                              ? "p-invalid"
                              : ""
                          }`}
                        />
                      </span>
                    </div>
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>

        {/* SECCIÓN 2: DETALLES INFORMATIVOS (READ ONLY) */}
        <div className="surface-100 p-2 border-round mb-3">
          <div className="flex flex-wrap gap-4 row-gap-2 text-sm">
            <label
              htmlFor="contacto"
              className="text-500 font-medium text-xs block mb-1"
            >
              Información Vendedor
            </label>
            {/* VENDEDOR */}
            <div>
              <span className="text-900 font-bold">
                {data.cliente?.vendedor
                  ? `${data.cliente.vendedor.codigo} - ${data.cliente.vendedor.descripcion}`
                  : "-"}
              </span>
            </div>

            {tipoDocumento !== "nota-venta" && (
              <>
                {/* OFICINA VENTA */}
                <div>
                  <span className="text-500 font-medium mr-1">
                    Oficina de Venta:
                  </span>
                  <span className="text-900 font-bold">
                    {data.almacen?.oficina || "-"}
                  </span>
                </div>

                {/* LISTA PRECIO */}
                <div>
                  <span className="text-500 font-medium mr-1">
                    Lista Precio:
                  </span>
                  <span className="text-900 font-bold">
                    {data.cliente?.listaPrecio?.descripcion || "-"}
                  </span>
                </div>

                {/* CONDICIÓN PAGO */}
                <div>
                  <span className="text-500 font-medium mr-1">
                    Condición Pago:
                  </span>
                  <span className="text-900 font-bold">
                    {data.cliente?.condicionPago
                      ? `${data.cliente.condicionPago.descripcion}`
                      : "E000"}
                  </span>
                </div>

                {data.interfaz !== "MAYORISTA" && (
                  <>
                    {/* CENTRO */}
                    <div>
                      <span className="text-500 font-medium mr-1">Centro:</span>
                      <span className="text-900 font-bold">
                        {data.almacen?.almacen || "No"} -{" "}
                        {data.almacen?.sucursal || "Definido"}
                      </span>
                    </div>

                    {/* FECHA DECISIÓN */}
                    <div>
                      <span className="text-500 font-medium mr-1">
                        F. Decisión:
                      </span>
                      <span className="text-900 font-bold">
                        {data.fecha || "-"}
                      </span>
                    </div>

                    {/* FECHA ENTREGA */}
                    <div>
                      <span className="text-500 font-medium mr-1">
                        F. Entrega:
                      </span>
                      <span className="text-900 font-bold">
                        {data.fechaEntrega || "-"}
                      </span>
                    </div>
                  </>
                )}
              </>
            )}
          </div>
        </div>

        {/* SECCIÓN 3: CONFIGURACIÓN DE LA VENTA */}
        <div className="mb-3 border-bottom-1 surface-border pb-3">
          <div className="text-900 font-bold text-sm mb-2">
            Configuración de Venta
          </div>
          <div className="grid p-fluid">
            {tipoDocumento !== "nota-venta" && ( // configuracion para boletas y facturas mayorista/retail
              <>
                {data.interfaz === "MAYORISTA" ? ( // solo para mayoristas se presenta la obra
                  // Obras
                  <div className="col-12 md:col-4">
                    <label
                      htmlFor="obra"
                      className="text-500 font-medium text-xs block mb-1"
                    >
                      Obra
                    </label>
                    <div className="p-inputgroup h-2rem">
                      <Dropdown
                        id="obra"
                        value={data.obra?.id || data.obra}
                        onChange={(e) => setData({ ...data, obra: e.value })}
                        options={data.obras || []}
                        optionLabel="descripcion"
                        optionValue="id"
                        placeholder="Seleccionar"
                        className="w-full p-inputtext-sm"
                        filter
                      />
                      {sessionStorage.getItem("authority") ===
                        "ROLE_ADMINISTRADOR" && (
                        <Button
                          icon="pi pi-plus"
                          className="p-button-outlined p-button-primary p-button-sm"
                          onClick={() => selectObra()}
                        />
                      )}
                    </div>
                  </div>
                ) : (
                  // para PROYECTOS para retail
                  //Proyectos
                  <div className="col-12 md:col-4">
                    <label
                      htmlFor="proyecto"
                      className="text-500 font-medium text-xs block mb-1"
                    >
                      Proyecto
                    </label>
                    <Dropdown
                      id="proyecto"
                      value={data.proyecto?.id || data.proyecto}
                      onChange={(e) => setData({ ...data, proyecto: e.value })}
                      options={data.proyectos || []}
                      optionLabel="descripcion"
                      optionValue="id"
                      placeholder="Seleccionar"
                      className="w-full p-inputtext-sm"
                      filter
                    />
                  </div>
                )}

                {/* ESTADOS */}
                <div className="col-12 md:col-4">
                  <label
                    htmlFor="estado"
                    className="text-500 font-medium text-xs block mb-1"
                  >
                    Estado
                  </label>
                  <Dropdown
                    id="estado"
                    value={data.estado?.id || data.estado}
                    onChange={(e) => setData({ ...data, estado: e.value })}
                    options={data.estados || []}
                    optionLabel="descripcion"
                    optionValue="id"
                    placeholder="Seleccionar"
                    className="w-full p-inputtext-sm"
                    itemTemplate={(option) => (
                      <span
                        className={`status-badge status-${option.descripcion.toLowerCase()}`}
                      >
                        {option.descripcion}
                      </span>
                    )}
                  />
                </div>

                {/* VALIDEZ */}
                <div className="col-12 md:col-4">
                  <label
                    htmlFor="validez"
                    className="text-500 font-medium text-xs block mb-1"
                  >
                    Validez Oferta
                  </label>
                  <div className="p-inputgroup h-2rem">
                    <Dropdown
                      id="validez"
                      value={data.validez || data.validezs?.[0]?.id}
                      onChange={(e) => setData({ ...data, validez: e.value })}
                      options={data.validezs || []}
                      optionLabel="descripcion"
                      optionValue="id"
                      placeholder="Seleccionar"
                      className="w-full p-inputtext-sm"
                      itemTemplate={(option) => (
                        <span
                          className={`status-badge status-${option.descripcion.toLowerCase()}`}
                        >
                          {option.descripcion}
                        </span>
                      )}
                    />
                    {sessionStorage.getItem("authority") ===
                      "ROLE_ADMINISTRADOR" && (
                      <Button
                        icon="pi pi-plus"
                        className="p-button-outlined p-button-primary p-button-sm"
                        onClick={() => selectValidez()}
                      />
                    )}
                  </div>
                </div>

                {data.interfaz === "MAYORISTA" && ( // solo para mayoristas se presenta el centro y permite seleccionar fecha de decision y fecha entrega
                  <>
                    {/* CENTRO */}
                    <div className="col-12 md:col-4">
                      <label
                        htmlFor="centro"
                        className="text-500 font-medium text-xs block mb-1"
                      >
                        Centro
                      </label>
                      <Dropdown
                        id="centro"
                        value={data.almacen}
                        options={data.almacens || []}
                        onChange={(e) => setData({ ...data, almacen: e.value })} // e.value es el objeto elegido
                        optionLabel="sucursal"
                        placeholder="Seleccionar"
                        className="w-full p-inputtext-sm"
                        filter
                      />
                    </div>

                    {/* FECHA DECISIÓN */}
                    <div className="col-12 md:col-4">
                      <label
                        htmlFor="fecha decision"
                        className="text-500 font-medium text-xs block mb-1"
                      >
                        Fecha Decisión
                      </label>
                      <Calendar
                        id="fecha decision"
                        value={data.fechaDecision}
                        onChange={(e) =>
                          setData({ ...data, fechaDecision: e.value })
                        }
                        className="w-full p-inputtext-sm"
                        minDate={new Date()}
                        dateFormat="dd/mm/yy"
                      />
                    </div>

                    {/* FECHA ENTREGA */}
                    <div className="col-12 md:col-4">
                      <label
                        htmlFor="fecha entrega"
                        className="text-500 font-medium text-xs block mb-1"
                      >
                        Fecha Entrega
                      </label>
                      <Calendar
                        id="fecha entrega"
                        value={data.fechaEntrega}
                        onChange={(e) =>
                          setData({ ...data, fechaEntrega: e.value })
                        }
                        className="w-full p-inputtext-sm"
                        minDate={new Date()}
                        dateFormat="dd/mm/yy"
                      />
                    </div>
                  </>
                )}
              </>
            )}
            {tipoDocumento === "nota-venta" && (
              <>
                {/* Condicion de pago */}
                <div className="col-12 md:col-4">
                  <label
                    htmlFor="condicion pago"
                    className="text-500 font-medium text-xs block mb-1"
                  >
                    Condición de Pago
                  </label>
                  <Dropdown
                    id="condicion pago"
                    optionLabel="descripcion"
                    placeholder="Seleccionar"
                    className="w-full p-inputtext-sm"
                  />
                </div>

                {/* condicion de entrega */}
                <div className="col-12 md:col-4">
                  <label
                    htmlFor="condicion entrega"
                    className="text-500 font-medium text-xs block mb-1"
                  >
                    Condición de Entrega
                  </label>
                  <div className="p-inputgroup">
                    <Dropdown
                      id="condicion entrega"
                      optionLabel="descripcion"
                      placeholder="Seleccionar"
                      className="w-full p-inputtext-sm"
                    />
                    <Button
                      icon="pi pi-cog"
                      className="p-button-outlined p-button-primary p-button-sm"
                      onClick={() => selectCondiciones()}
                      title="Editar Condición de Entrega"
                    />
                  </div>
                </div>

                {/* sucursal */}
                <div className="col-12 md:col-4">
                  <label
                    htmlFor="sucursal"
                    className="text-500 font-medium text-xs block mb-1"
                  >
                    Sucursal
                  </label>
                  <Dropdown
                    id="sucursal"
                    optionLabel="sucursal"
                    placeholder="Seleccionar"
                    className="w-full p-inputtext-sm"
                  />
                </div>
              </>
            )}
          </div>
        </div>

        <div className="flex col-12 justify-content-center gap-2">
          <Button
            label={
              tipoDocumento === "nota-venta" ? "Confirmar" : "Cotización Normal"
            }
            className="p-button-primary p-button-sm w-5"
            icon={loading ? "pi pi-spin pi-spinner" : "pi pi-check"}
            onClick={() => {
              cotizacionNormal();
            }}
          />
          {data.interfaz === "MAYORISTA" && (
            <Button
              label="Cotización Especial"
              className="p-button-success p-button-sm w-5"
              icon="pi pi-check"
              disabled
            />
          )}
        </div>
      </div>

      <ValidezDialog
        visible={isValidezDialogVisible}
        onCancel={() => setIsValidezDialogVisible(false)}
        codigo={codigoCliente}
        onChangeValidezLista={handleValidezListaChange}
      />
      <ObrasDialog
        visible={isObraDialogVisible}
        onCancel={() => setIsObraDialogVisible(false)}
        codigo={codigoCliente}
        data={data}
        onChangeObrasLista={handleObrasListaChange}
      />

      <CondicionesDialog
        visible={isCondicionesDialogVisible}
        onHide={() => setIsCondicionesDialogVisible(false)}
        data={data}
        onCondicionesChange={handleCondicionesChange}
      />
    </>
  );
};

export default Cabecera;
